import { useFeatureValue } from '@growthbook/growthbook-react'
import React from 'react'
import { Popconfirm } from 'antd'
import { DropdownMenu } from 'modules/core/components'
import { useTranslation } from 'react-i18next'
import { EditOutlined, DeleteOutlined, SolutionOutlined, CopyOutlined } from '@ant-design/icons'

const MoreActions = ({
  title,
  loading,
  onConfirmPopconfirm,
  onCancelPopconfirm,
  visible,
  onClickEdit,
  type,
  onClickDuplicate,
  onClickDelete,
  onOpenActivities,
  module = 'forecast',
}) => {
  const actionCrudByRole = useFeatureValue('feature-action-crud-role', {
    planning: 'True',
    forecast: 'True',
  })
  const { t } = useTranslation()

  const getDisabledByRole = () => {
    switch (module) {
      case 'planning':
      case 'globalBudget':
        return !(actionCrudByRole.planning === 'True')
      case 'forecast':
      case 'globalForecast':
        return !(actionCrudByRole.forecast === 'True')
      default:
        return false
    }
  }

  return (
    <Popconfirm
      placement="bottomRight"
      title={t('POPCONFIRM_DELETE_DEFAULT_TITLE', { name: title })}
      okText={t('ACTION_DELETE')}
      okButtonProps={{ loading }}
      onConfirm={onConfirmPopconfirm}
      cancelText={t('ACTION_CANCEL')}
      onCancel={onCancelPopconfirm}
      visible={visible}
    >
      <DropdownMenu
        title={t('ACTION_MORE')}
        onClick={(e) => e.stopPropagation()}
        menu={[
          {
            title: t('ACTION_EDIT_NAME'),
            icon: <EditOutlined />,
            onClick: onClickEdit,
            disabled: getDisabledByRole(),
          },
          {
            title: t('ACTION_DUPLICATE'),
            icon: <CopyOutlined />,
            onClick: onClickDuplicate,
            disabled: getDisabledByRole(),
          },
          {
            title: t('ACTION_DELETE'),
            icon: <DeleteOutlined />,
            onClick: onClickDelete,
            disabled: getDisabledByRole(),
          },
          ...(onOpenActivities
            ? [
                {
                  title: t('ACTION_ACTIVITIES'),
                  icon: <SolutionOutlined />,
                  onClick: onOpenActivities,
                },
              ]
            : []),
        ]}
      />
    </Popconfirm>
  )
}

export default MoreActions
